export default {
    en:{
        achvmPlanType:'Evaluation Type',
        promotion: 'Promotion',
        reappointment: 'Reappointment',
        payGradeIncrease: 'Pay Grade Increase',
        list:{
            period:'Period',
            title:'Title',
            regDt:'Date',
        },
        detail:{
            period:'Evaluation Period',
            officialFile:'Approved documents',
            attachFile:'Attachments',
        },
        help:{
            title:'How to upload AP',
            line1:'Please submit the copy of a final version of AP (.pdf) approved by dept./college personnel committee.',
            line2:'Please confirm that selecting period and evaluation type are the same as the file data.',
        },
        alert:{
            content:'Achievement Plan is saved.',
        },
    },
    ko:{
        achvmPlanType:'심사구분',
        promotion: '승진',
        reappointment: '재임용',
        payGradeIncrease: '승봉',
        list:{
            period:'기간',
            title:'제목',
            regDt:'등록일자',
        },
        detail:{
            period:'업적기간',
            officialFile:'관련공문',
            attachFile:'첨부파일',
        },
        help:{
            title:'업적계획서 제출(업로드) 안내',
            line1:'업적계획서는 소속 학과(부)/대학(원) 인사위원회를 거쳐 승인된 최종본을 스캔하여 pdf 형식으로 업로드해 주시기 바랍니다. ',
            line2:'심사구분 및 업적기간는 업로드하는 업적계획서 상단에 명시된 데이터와 동일하게 선택하여 제출해 주시기 바랍니다.',
        },
        alert:{
            content:'업적계획서가 저장되었습니다.',
        }
    }
}